import { call, put, select, takeLatest } from 'redux-saga/effects';
import { REMOVE_AVATAR, SET_AVATAR } from './constants';
import { avatarDone } from './actions';
import * as users from '../services/user';
import { loginSuccess } from '../Login/actions';
import { selectAccessToken } from '../Login/selectors';
import { shrinkPhoto } from './shrinkPhoto';

// The server answers with you, updated: keep it as the signed-in user. A refused upload shows in the app's errors.
function* avatarTask(action) {
  try {
    const user = action.type === SET_AVATAR
      ? yield call(users.setAvatar, yield call(shrinkPhoto, action.payload.file))
      : yield call(users.removeAvatar);
    yield put(loginSuccess(user, yield select(selectAccessToken)));
  } finally {
    yield put(avatarDone());
  }
}

function* avatarWatcher() {
  yield takeLatest([SET_AVATAR, REMOVE_AVATAR], avatarTask);
}

export default [
  avatarWatcher,
];
